<button (click)="openScheduleDialog()"
  color="primary"
  mat-button
  type="button">
  <mat-icon style="margin-right: 5px">add</mat-icon>
  <mat-label>{{ 'SCHEDULE.add' | translate }}</mat-label>
</button>

@if (schedulesValue.length ) {
  <mat-list>
    <div mat-subheader>{{ 'SCHEDULE.title' | translate }}</div>
    <div class="list">
      @for (schedule of schedulesValue; track schedule; let i = $index) {
        <mat-list-item lines="2">
          <span matListItemTitle>{{ getDaysLabel(schedule.days) | async }}</span>
          <span matListItemLine>{{ convertTime(schedule.hour, schedule.minute) }}</span>
          <span matListItemMeta class="schedule-actions">
            <button (click)="openScheduleDialog(i)" type="button" color="primary" mat-icon-button [aria-label]="'SCHEDULE.edit' | translate">
              <mat-icon>edit</mat-icon>
            </button>
            <button (click)="removeSchedule(i)" type="button" color="warn" mat-icon-button [aria-label]="'SCHEDULE.remove' | translate">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>
        </mat-list-item>
        @if (i !== schedulesValue.length - 1) {
          <mat-divider></mat-divider>
        }
      }
    </div>
  </mat-list>
}
